
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 85.7 8.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M85.7 8.7c-4.8 0-7.3-1.1-9.6-2.1-2-.9-3.8-1.6-7.6-1.6S63 5.8 61 6.6c-2.2 1-4.8 2.1-9.6 2.1s-7.3-1.1-9.6-2.1C39.8 5.8 38 5 34.3 5s-5.5.8-7.6 1.6c-2.2 1-4.8 2.1-9.6 2.1S9.8 7.6 7.5 6.6C5.5 5.8 3.8 5 0 5V0c4.8 0 7.3 1.1 9.6 2.1 2 .9 3.8 1.6 7.6 1.6s5.5-.8 7.6-1.6C27 1.1 29.6 0 34.4 0s7.3 1.1 9.6 2.1c2 .9 3.8 1.6 7.6 1.6S57 2.9 59 2.1c2.2-1 4.8-2.1 9.6-2.1s7.3 1.1 9.6 2.1c2 .9 3.8 1.6 7.6 1.6v5z","fill":"#95c8da"}})])
          )
        }
      }
    